const Base = process.env.REACT_APP_BACKEND_URL;
const SendEmailEndpoint = process.env.REACT_APP_AWS_SEND_EMAIL_URL;

export { Base, SendEmailEndpoint };
